// extracted by mini-css-extract-plugin
export default {"fitContent":"app-project-purchase-list_fitContent__LrW7E"};